
import { Component, Vue } from "vue-property-decorator";
import WorldCupComponent from "@/libs/WorldCupComponent";
import { mapState } from "vuex";
import Deferrable from "@/libs/common/delegate/Deferrable";
import { Duct } from "@/libs/Duct";
import Defer from "@/libs/Defer";
import * as lob from "lodash/object";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({
  components: {},
  computed: {
    ...mapState({
      worldCupMatches: "worldCupMatches",
    }),
  },
})
export default class MatchTable
  extends WorldCupComponent
  implements Deferrable
{
  config: any;
  worldCupMatches: any;
  isPreloaded: boolean;
  isMounted: boolean;
  defer: Defer;
  getMatches(): Array<MatchInterface> {
    let data = this.getStoreData(this.worldCupMatches);
    if (!data) {
      return [];
    }

    if (!data.match) {
      return [];
    }

    return data.match;
  }

  getContestant(item: MatchInterface) {
    if (!item.matchInfo) {
      return "";
    }

    if (!item.matchInfo.contestant) {
      return "";
    }

    let contestants = item.matchInfo.contestant;
    return contestants[0].name + " vs " + contestants[1].name;
  }

  getResult(item: MatchInterface) {
    let liveData = item.liveData;
    if (!liveData) {
      return "--";
    }
    let matchDetails = liveData.matchDetails;
    if (!matchDetails) {
      return "--";
    }

    let scores = matchDetails.scores;
    if (!scores) {
      return "--";
    }

    return `HOME: ${scores.total.home} / AWAY: ${scores.total.away}`;
  }

  created() {
    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted() {
    this.isMounted = true;
    this.onDebug(this, "MatchTable:mounted", {});
  }

  onDefer() {
    if (this.isPreloaded && this.isMounted) {
      return false;
    }
    return true;
  }

  onReady() {}

  onPreloadDone() {
    this.isPreloaded = true;
  }
}
